import { render, staticRenderFns } from "./dataTable_withAdd.vue?vue&type=template&id=62f116db&scoped=true&"
import script from "./dataTable_withAdd.vue?vue&type=script&lang=js&"
export * from "./dataTable_withAdd.vue?vue&type=script&lang=js&"
import style0 from "./dataTable_withAdd.vue?vue&type=style&index=0&id=62f116db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f116db",
  null
  
)

export default component.exports